import { Badge } from '@/shared/ui/Badge';

import type { Email } from './types';

/**
 * «Estaba en spam» on a row the connector read from the spam folder (rescue mode,
 * contract v10.4), «Rescatado» once a person copied it to the inbox and the connector
 * brought the copy in. Nothing for an inbox row.
 */
export function SpamBadge({ email }: { email: Pick<Email, 'in_spam' | 'rescued_at'> }) {
  if (email.in_spam) {
    return (
      <Badge
        tone="warn"
        title="El filtro del buzón lo mandó a la carpeta de spam. Nada actúa sobre él."
      >
        Estaba en spam
      </Badge>
    );
  }
  if (email.rescued_at) {
    return (
      <Badge tone="info" title="Alguien lo rescató de la carpeta de spam.">
        Rescatado
      </Badge>
    );
  }
  return null;
}
